export default theme => ({
    input: {
        maxWidth: 500
    },
    textFieldWrapper: {
        position: 'relative',
        maxWidth: 500,
        marginTop: 30
    },
    buttonRoot: {
        position: 'absolute',
        right: 13,
        top: 29,
        zIndex: 1,
        fontSize: 12,
        fontWeight: 'bold',
        lineHeight: 1.17,
        letterSpacing: 0.2,
        color: theme.palette.primary,
        backgroundColor: 'rgb(255, 255, 255)',
        '&:hover': {
            backgroundColor: 'rgb(245, 245, 245)'
        }
    },
    saveButton: {
        padding: '10px 100px',
        fontWeight: 'bold'
    },
    resetButton: {
        padding: '10px 30px',
        fontWeight: 'bold'
    },
    heading: {
        fontSize: 16,
        fontWeight: 600,
        lineHeight: '28px',
        marginBottom: 15
    },
    textFieldLabel: {
        fontSize: 10,
        color: theme.palette.grey[700],
        fontWeight: 600,
        marginBottom: 10,
        marginTop: -7
    },
    subtitle: {
        color: '#3A3C43',
        fontSize: 16,
        fontWeight: 700,
        marginTop: 30,
        marginBottom: 14
    },
    numberInput: {
        width: 60
    }
});
